import { type UseQueryResult, useQuery } from 'react-query';
import { VendorTermsAndConditionsService } from '../../services/wealthlane-customer-services';

const useGetVendorTermAndConditionPageList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const VendorTermAndConditionPageList = useQuery(
    ['getVendorTermAndConditionPageList'],
    async () => {
      return await handleRequest(
        VendorTermsAndConditionsService.getApiCustomerApiVendorTermsAndConditionsPages()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return VendorTermAndConditionPageList;
};

export default useGetVendorTermAndConditionPageList;
